<template>
  <div
    ref="optCate"
    :class="['wrap_opt', listType === 'business' ? 'type_top' : 'type_normal']"
  >
    <div :class="['selected_item', { type_selected: inputValue }]">
      <button
        type="button"
        :aria-expanded="`${isOpen}`"
        aria-haspopup="listbox"
        class="btn_opt"
        @click="toggleOpt"
      >
        <span>{{ inputValue.name }}</span>
      </button>
    </div>
    <strong class="screen_out">선택 항목 목록</strong>
    <ul :class="['list_opt', { active: isOpen }]">
      <li
        v-for="(item, idx) in optList"
        :key="`news_cate_${idx}`"
        :class="{ on: item.isSelected }"
      >
        <button
          type="button"
          class="btn_select"
          @click="selectItem(idx)"
        >
          {{ item.name }}
        </button>
      </li>
    </ul>
  </div>
</template>
<!-- 사용시
<SelectCate
  :optList="listNewsCate"
  @selectItem="selectItem"
/>
-->
<script setup>
const emit = defineEmits(['selectItem']);
const isOpen = ref(false);
const optCate = ref();
const props = defineProps({
  optList: {
    type: Array,
    default: [],
  },
  styleType: {
    type: String,
    default: '',
  },
});

const toggleOpt = () => {
  isOpen.value = !isOpen.value;
};

const inputValue = computed(() => {
  return props.optList.find((ele) => ele.isSelected);
});

const listType = computed(() => {
  return props.styleType === 'selectTop' ? 'business' : '';
});

const selectItem = (index) => {
  emit('selectItem', index, listType.value);

  toggleOpt();
};

const changeOpenValue = () => {
  isOpen.value = false;
};

onMounted(() => {
  window.addEventListener('scroll', changeOpenValue);

  document.addEventListener('click', (e) => {
    const clickEle = e.target;
    if (clickEle.closest('.wrap_opt') !== optCate.value) {
      isOpen.value = false;
    }
  });
});

onUnmounted(() => {
  window.removeEventListener('scroll', changeOpenValue);
});
</script>
<style lang="scss" scoped>
.wrap_opt.type_normal {
  //셀렉트
  position: relative;
  width: 100%;
  .btn_opt {
    width: 100%;
    height: 54px;
    padding: 0 12px;
    line-height: 54px;
    border-bottom: 1px solid #e5e5e5;
    font-size: 18px;
    letter-spacing: -0.5px;
    text-align: left;
    @include backgroundImage(
      "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='m8.504 10 3.504-4H5l3.504 4z' fill='%23222'/%3E%3C/svg%3E",
      16px 16px,
      top 19px right 12px
    );
  }
  .list_opt {
    display: none;
    position: absolute;
    z-index: 1;
    width: 100%;
    padding: 8px 0;
    background-color: #fff;
    top: 54px;
    border: 1px solid #000;
    &.active {
      display: block;
    }
    li {
      button {
        width: 100%;
        height: 54px;
        padding: 0 12px;
        font-size: 18px;
        letter-spacing: -0.5px;
        color: #999;
        text-align: left;
      }
      &.on {
        button {
          color: #1a1a1a;
        }
      }
      &:hover {
        background: #f8f8f8;
      }
    }
  }
}

@media screen and (max-width: 1023px) {
  .wrap_opt.type_normal {
    .btn_opt {
      font-size: 22px;
    }
  }
  .wrap_opt.type_top {
    //셀렉트
    position: relative;
    background-color: #fff;
    .btn_opt {
      height: 32px;
      padding: 0 24px 0 0;
      line-height: 32px;
      font-size: 22px;
      font-weight: 700;
      @include backgroundImage(
        "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='none'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='m12 14.5 3.5-5h-7l3.5 5z' fill='%231A1A1A'/%3E%3C/svg%3E",
        24px 24px,
        top 4px right
      );
      &[aria-expanded='true'] {
        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='none'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='m12 14.5 3.5-5h-7l3.5 5z' fill='%235887FF'/%3E%3C/svg%3E");
      }
    }

    .list_opt {
      display: none;
      position: fixed;
      z-index: 1;
      width: 100%;
      padding-bottom: 16px;
      background-color: #fff;
      top: 80px;
      left: 0;
      &.active {
        display: block;
      }
      li {
        button {
          width: 100%;
          height: 72px;
          line-height: 72px;
          padding: 0 40px;
          font-size: 22px;
          letter-spacing: -0.5px;
          color: #999;
          text-align: left;
        }
        &.on {
          button {
            color: #1a1a1a;
            font-weight: 700;
          }
        }
        &:hover {
          background: unset;
        }
      }
    }
  }
}
@media screen and (max-width: 811px) {
  .wrap_opt.type_top {
    .btn_opt {
      font-size: 18px;
    }
    .list_opt {
      top: 60px;
      li {
        button {
          line-height: 51px;
          height: 51px;
          padding: 0 20px;
          font-size: 18px;
        }
      }
    }
  }
  .wrap_opt.type_normal {
    .btn_opt {
      font-size: 18px;
    }
    .list_opt {
      li {
        button {
          line-height: 54px;
          height: 54px;
          padding: 0 20px;
          font-size: 18px;
        }
      }
    }
  }
}
</style>
